import React from "react";
import OrderForm from "../components/OrderForm";

export default function NAForm({ isVisible }) {
  return (
    <div className={isVisible ? "" : " not-visible"}>
      <p className="tel-pt-view-description">
        Osäker på vilket fibernätverk du har? Fyll i formuläret nedan, så hjälper vi dig att reda ut det!
      </p>
      <OrderForm isNaForm={true} />
    </div>
  );
}
